import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import { LogLookupsServerData, LogsAction, LogsServerData, LogsRequestAttributes } from './logs.types'

export class LogsProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return this.baseUrl
  }

  public get(attributes: LogsRequestAttributes): Promise<HttpServiceResponse<LogsServerData>> {
    const queryString = qs.stringify({
      action: LogsAction.Find,
      StartDateTime: attributes.startDate,
      EndDateTime: attributes.endDate,
      App: attributes.app,
      Module: attributes.module,
      SortOrder: attributes.order,
      Tag: attributes.tag,
      LogLevel: attributes.level,
      PageNumber: attributes.page,
    })

    return this.http.post(`${this.url}/log_search_api.php?${queryString}`)
  }

  public lookups(): Promise<HttpServiceResponse<LogLookupsServerData>> {
    return this.http.post(`${this.url}/log_lookups_api.php?action=${LogsAction.App}`)
  }
}
